import { Badge, Icon } from "@oysterhr/ui"
import classNames from "classnames"
import { useTranslation } from "react-i18next"

interface IntegrationBadgeProps {
  id?: string
  isPullField: boolean
  className?: string
}

export const IntegrationBadge = ({ id, isPullField, className }: IntegrationBadgeProps) => {
  const { t } = useTranslation("integrations/HRIS")
  return (
    <Badge
      className={classNames("ml-2 whitespace-nowrap", className)}
      aria-label={`${id}-IntegrationBadge`}
      variation="gray"
    >
      <Icon name={isPullField ? "DownloadSimple" : "UploadSimple"} />
      {t(`${isPullField ? "pulledFromHris" : "pushedToHris"}`)}
    </Badge>
  )
}
